import styled from 'styled-components';

export const StyledForColumnsSpan = styled.div`
   grid-column: 1 / span 4;
`;

StyledForColumnsSpan.displayName = 'StyledTwoColumnsSpan';

export const StyledForm = styled.form`
   display: grid;
   grid-template-columns: repeat(4, 1fr);
   column-gap: 36px;
   row-gap: 24px;
`;

StyledForm.displayName = 'StyledForm';
